import { createFileRoute } from "@tanstack/react-router";
import { ToolPage } from "@/components/dashboard/ToolPage";
import { PropFirmChallengeCalculator } from "@/components/tools/PropFirmChallengeCalculator";

export const Route = createFileRoute("/_authenticated/dashboard/prop-firm")({
  head: () => ({
    meta: [
      { title: "Prop Firm Challenge Calculator | XAU Pro Academy" },
      { name: "description", content: "Daily and overall drawdown room, sizing and target distance for funded gold accounts." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: PropFirmPage,
});

function PropFirmPage() {
  return (
    <ToolPage eyebrow="Funded desk" title="Prop Firm Challenge Calculator" intro="Remaining room under the daily and overall loss limits, how many full losses that allows and the lot size for your stop.">
      <PropFirmChallengeCalculator />
    </ToolPage>
  );
}
